<script setup lang="ts">
import ScoutsLogo from "@/components/Common/ScoutsLogo.vue";
import LoadingSpin from "@/components/Common/LoadingSpin.vue";
import ContentHolder from "@/components/RegistrationPage/MobileVersion/ContentHolder.vue";
import {default as templateStore} from "@/store";
import BonusDescriptionModal from "@/components/RegistrationPage/MobileVersion/BonusDescriptionModal.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'RegistrationPageMobileVersion',
})
</script>

<template>
    <div class="main">
        <div class="wrapper">
            <ScoutsLogo/>

            <Transition name="fade" mode="out-in">
                <LoadingSpin v-if="templateStore.state.passes.length === 0"/>
                <ContentHolder v-else/>
            </Transition>
        </div>

        <BonusDescriptionModal/>
    </div>
</template>

<style scoped lang="scss">
.main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 30px 0 0 0;
    overflow: hidden;
    overflow-y: scroll;

    display: block;
}

.wrapper {
    position: relative;
    z-index: 900;
    width: fit-content;
    padding: 0 20px 0 20px;
    margin: 0 auto;

    flex: 1;
    font-size: 14px;

    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: flex-start;
    align-items: center;
}
</style>
